import { render, staticRenderFns } from "./QuestionManagement.vue?vue&type=template&id=9fae028c&scoped=true&"
import script from "./question-management.js?vue&type=script&lang=js&"
export * from "./question-management.js?vue&type=script&lang=js&"
import style0 from "./QuestionManagement.vue?vue&type=style&index=0&id=9fae028c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fae028c",
  null
  
)

export default component.exports